import React from 'react';
import PropTypes from 'prop-types';
import { designSystem, Modal } from '@yola/ws-ui';
import bowser from 'yola-bowser';

const {
  DialogHeader,
  DialogHeaderTitle,
  DialogHeaderControls,
  DialogHeaderIconButton,
  Divider,
  Box,
  ModalButtonGroup,
  ActionButton,
} = designSystem;

const WIDTH = 600;
const overlaySpacing = { y: 50 };

const DifmBannerModal = ({
  isLoading = false,
  onClose,
  onBack = null,
  onNext,
  isNextDisabled = false,
  children,
  captions,
}) => (
  <Modal
    isBodyScrollDisabled
    isContainerScrollable
    centered
    width={WIDTH}
    height="auto"
    resizable={false}
    draggable={false}
    overlaySpacing={overlaySpacing}
    fullscreen={bowser.mobile}
    overlay="visible"
    className="ws-difm-banner-modal"
  >
    <DialogHeader>
      <DialogHeaderTitle>{captions.title}</DialogHeaderTitle>
      <DialogHeaderControls>
        <DialogHeaderIconButton onClick={onClose} disabled={isLoading} glyph="close" />
      </DialogHeaderControls>
    </DialogHeader>
    <Divider />
    <div className="ws-difm-banner-modal__content">
      <Box
        paddingTop="spacing-s"
        paddingBottom="spacing-s"
        paddingLeft="spacing-m"
        paddingRight="spacing-m"
      >
        {children}
      </Box>
    </div>
    <ModalButtonGroup direction="right">
      <ActionButton
        appearance="accent"
        format="solid"
        label={captions.next}
        isLoading={isLoading}
        disabled={isNextDisabled}
        onClick={onNext}
      />
      <React.Fragment />
      {onBack && (
        <ActionButton
          label={captions.back}
          disabled={isLoading}
          onClick={onBack}
          iconGlyph="back"
        />
      )}
    </ModalButtonGroup>
  </Modal>
);

DifmBannerModal.propTypes = {
  isLoading: PropTypes.bool,
  onBack: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  onNext: PropTypes.func.isRequired,
  isNextDisabled: PropTypes.bool,
  captions: PropTypes.shape({
    back: PropTypes.string,
    title: PropTypes.string,
    next: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default DifmBannerModal;
